import { render, staticRenderFns } from "./LicenseInput.vue?vue&type=template&id=4f8b14b6&scoped=true"
import script from "./LicenseInput.vue?vue&type=script&lang=js"
export * from "./LicenseInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b14b6",
  null
  
)

export default component.exports